import { createSlice } from "@reduxjs/toolkit";

const initialState= {
    allDates: {
        weekly: [],
        biWeekly: [],
        monthly: [],
        quarterly: [],
        halfYearly: [],
    },

    weeklyData: {
        firstSources: [],
        lastSources: [],
        uniqueSales: []
    },
    biWeeklyData: {
        firstSources: [],
        lastSources: [],
        uniqueSales: []
    },
    monthlyData: {
        firstSources: [],
        lastSources: [],
        uniqueSales: []
    },
    quarterlyData: {
        firstSources: [],
        lastSources: [],
        uniqueSales: []
    },
    halfYearlyData: {
        firstSources: [],
        lastSources: [],
        uniqueSales: []
    },


    firstSources: [],
    lastSources: [],
    uniqueSales: [],

    originalFirstSources: [],
    originalLastSources: [],
    originalUniqueSales: [],

    dates: [],
    currentDate: 0,
    dateType: 0,
    pages: [],
    page: 0,


    // New UI States 
    secondLevelStates: [],
    graph2: {
        currentDate: 0, 
        dateType: 0,
        dates: [],
        weeklyData: [],
        currentSources: [],
        weekly: [],
        biWeekly: [],
        monthly: [],
        quarterly: [],
        halfYearly: [],
        yearly: [],     
        weeklyData: [],
        biWeeklyData: [],
        monthlyData: [], 
        quarterlyData: [],
        halfYearlyData: [],
    },
}
const firstLastSlice = createSlice({
    name: 'firstLast',
    initialState,
    reducers: {
        setAllDates: (state, action) => {
            state.allDates = action.payload
        },
        setCurrentDate: (state, action) => {
            state.currentDate = action.payload
        },
        setDateType: (state, action) => {
            state.dateType = action.payload
        },

        setFirstSources: (state,action) => {
            state.firstSources = action.payload
        },
        setLastSources: (state,action) => {
            state.lastSources = action.payload
        },
        setUniqueSales: (state,action) => {
            state.uniqueSales = action.payload
        },

        // Original states for search bars
        setOriginalFirstSources: (state,action) => {
            state.originalFirstSources = action.payload
        },
        setOriginalLastSources:(state,action) => {
            state.originalLastSources = action.payload
        },
        setOriginalUniqueSales: (state,action) => {
            state.originalUniqueSales = action.payload
        },


        // Data states dependent on current date type
        setWeeklyData: (state,action) => {
            state.weeklyData = action.payload
        },
        setBiWeeklyData: (state,action) => {
            state.biWeeklyData = action.payload
        },
        setMonthlyData: (state,action) => {
            state.monthlyData = action.payload
        },
        setQuarterlyData: (state,action) => {
            state.quarterlyData = action.payload
        },
        setHalfYearlyData: (state,action) => {
            state.halfYearlyData = action.payload
        },


        // Current dates displayed 
        setDates: (state,action) => {
            state.dates = action.payload
        },
        
        setPage: (state,action) => {
            state.page = action.payload
        },
        setPages: (state,action) => {
            state.pages = action.payload
        },






        setWeeklyData2: (state,action) => {
            state.graph2.weeklyData = action.payload
        },
        setBiWeeklyData2: (state,action) => {
            state.graph2.biWeeklyData = action.payload
        },
        setMonthlyData2: (state,action) => {
            state.graph2.monthlyData = action.payload
        },
        setQuarterlyData2: (state,action) => {
            state.graph2.quarterlyData = action.payload
        },
        setHalfYearlyData2: (state,action) => {
            state.graph2.halfYearlyData = action.payload
        },
 


        setSecondLevelStates: (state,action) => {
            state.secondLevelStates = action.payload
        },
        setCurrentDate2: (state,action) => {
            state.graph2.currentDate = action.payload
        },
        setDateType2: (state,action) => {
            state.graph2.dateType = action.payload
        },
        setDates2: (state,action) => {
            state.graph2.dates = action.payload
        },

        setCurrentSources: (state,action) => {
            state.graph2.currentSources = action.payload
        },
        setAllDates2: (state, action) => {
            state.graph2.weekly = action.payload.weekly
            state.graph2.biWeekly = action.payload.biWeekly
            state.graph2.monthly = action.payload.monthly
            state.graph2.quarterly = action.payload.quarterly
            state.graph2.halfYearly = action.payload.halfYearly

        },
        resetFirstlastSlice: (state, action) => {
            return { ...initialState };
          }


    }
})

export const { 
    setAllDates, setCurrentDate, setDateType,
    setFirstSources, setLastSources, setUniqueSales, 
    setWeeklyData, setBiWeeklyData, setMonthlyData, setQuarterlyData, setHalfYearlyData, setYearlyData,
    setOriginalFirstSources, setOriginalLastSources, setOriginalUniqueSales,
    setDates, setPage, setPages,
    setSecondLevelStates, setCurrentDate2, setDateType2, setDates2, setAllDates2,
    setWeeklyData2, setBiWeeklyData2, setMonthlyData2, setQuarterlyData2, setHalfYearlyData2,setCurrentSources,resetFirstlastSlice
} = firstLastSlice.actions

export default firstLastSlice.reducer